<template>
  <div class="row">
    <div class="col-md-6">
      <span>System Lookups</span>
      <div class="custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="(item, idx) in systems" :key="idx">
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-6">
      <span>Location Lookups</span>
      <div class="custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="(item, idx) in locations" :key="idx">
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
export default {
  name: 'MatrixMakeLookups',
  props: {
    matrix: {
      type: Object,
      default: null
    }
  },
  mounted() {
    if (this.matrix) {
      this.getAdasMakeMatrix(this.matrix.adasChecklistMatrixVehicle)
    }
  },
  computed: {
    ...mapState(adasmatrixStore, ['adasmakematrix']),
    systems() {
      let _data = []
      if (this.adasmakematrix) {
        if (this.adasmakematrix.systems) {
          this.adasmakematrix.systems.forEach((element) => {
            _data.push(element)
          })
        }
      }
      return _data
    },
    locations() {
      let _data = []
      if (this.adasmakematrix) {
        if (this.adasmakematrix.locations) {
          this.adasmakematrix.locations.forEach((element) => {
            _data.push(element)
          })
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getAdasMakeMatrix'])
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  max-height: 120px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-list {
  list-style-type: none;
  padding-inline-start: 10px;
  li {
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-right: 8px;
  }
}
</style>
